// @flow

import React from 'react'
import PreWrap from 'components/atoms/PreWrap'

export type PropTypes = {
  sectionTitle: string,
  isOpen: boolean,
  onClickReadmore: Function,
  children: HTMLElement,
}

export default class DetailMainSection extends React.Component<Object> {
  constructor(props: PropTypes) {
    super(props)
    this.checkShouldShort = this.checkShouldShort.bind(this)
  }

  checkShouldShort() {
    if (this.realArea) {
      const realHeight = this.realArea.getBoundingClientRect().height
      if (this.textArea) {
        const textHeight = this.textArea.getBoundingClientRect().height
        if (textHeight < realHeight) {
          this.props.onClickReadmore()
        }
      }
    }
  }

  props: PropTypes
  checkShouldShort: Function
  realArea: ?HTMLElement
  textArea: ?HTMLElement

  render() {
    const { isOpen, children, onClickReadmore } = this.props
    this.checkShouldShort()

    return (
      <section className="space-main__section">
        <h2 className="space-main__headline">{this.props.sectionTitle}</h2>
        <div className="" itemProp="description">
          <div className="space-expandable">
            <div
              className={`${isOpen ? '' : 'space-expandable__area'}`}
              ref={v => {
                this.realArea = v
                this.checkShouldShort()
              }}
            >
              <PreWrap
                innerref={v => {
                  this.textArea = v
                  this.checkShouldShort()
                }}
              >
                {children}
              </PreWrap>
            </div>
            {isOpen ? null : (
              <p className="space-expandable__link">
                <a
                  href="#"
                  className="a__underline"
                  onClick={e => {
                    e.preventDefault()
                    onClickReadmore()
                  }}
                >
                  {i18n.t('page.room.readmore')}
                  <i className="fa fa-angle-down ml5" />
                </a>
              </p>
            )}
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailMainSection/index.jsx